const Tabs = ({ children }) => {
  const classNames = 'integration__tabs';

  return <div className={classNames}>{children}</div>;
};

export default Tabs;
